import "../../styles/section7.css";
import OwnDrawingBtn from "./OwnDrawingBtn";
import { FadeAnimate } from "../../components/animateEffect/Fade";
import Image from "../../components/Image";
import BeforeAR from "../../static/2.png";
import AfterAR from "../../static/1.png";

const Section7 = () => {
  const benefits = [
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Better Accuracy",
      description: "Guides help you draw correct shapes and proportions.",
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/>
          <line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/>
          <line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
      ),
      title: "Enhanced Creativity",
      description: "Focus on colors, patterns, and details without worrying about mistakes.",
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline points="17 6 23 6 23 12" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Faster Learning",
      description: "Your drawing skills improve naturally over time.",
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline points="22 4 12 14.01 9 11.01" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Consistent Results",
      description: "Every piece of art looks neat and professional.",
    },
  ];

  return (
    <div className="section7Container">
      <div className="section7Wrapper">
        <div className="section7LeftPanel">
          <FadeAnimate>
            <h2 className="section7MainTitle">
              MAKE EVERY SKETCH BETTER WITH<br />
              <span className="section7Highlight">AR DRAWING</span>
            </h2>
            <p className="section7Subtitle">Unlock your creative potential.</p>
          </FadeAnimate>

          <div className="section7BenefitsList">
            {benefits.map((benefit, index) => (
              <FadeAnimate key={index}>
                <div className="section7BenefitItem">
                  <div className="section7BenefitIcon">{benefit.icon}</div>
                  <div className="section7BenefitText">
                    <h4>{benefit.title}</h4>
                    <h6>{benefit.description}</h6>
                  </div>
                </div>
              </FadeAnimate>
            ))}
          </div>

          <div className="section7Description">
            <p>
              With Draw in AR, every creation becomes cleaner, more balanced, and visually
              appealing. The app helps you focus on details and flow while reducing errors.
            </p>
          </div>
        </div>

        <div className="section7RightPanel">
          <FadeAnimate>
            <div className="section7ComparisonContainer">
              <div className="section7BeforeAfter">
                <div className="section7ComparisonItem">
                  <h3 className="section7ComparisonLabel">BEFORE AR</h3>
                  <div className="section7ImageFrame">
                    <Image
                      src={BeforeAR}
                      alt="Before AR Drawing"
                      className="section7EyeImage"
                      loading="lazy"
                    />
                  </div>
                </div>

                <div className="section7ComparisonItem">
                  <h3 className="section7ComparisonLabel">AFTER AR</h3>
                  <div className="section7ImageFrame">
                    <Image
                      src={AfterAR}
                      alt="After AR Drawing"
                      className="section7EyeImage section7EyeImageAfter"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              <div className="section7BottomCTA">
                <h2 className="section7CTATitle">
                  DRAW BETTER WITH<br />
                  <span className="section7Highlight">AR DRAWING</span>
                </h2>
                <OwnDrawingBtn title="Draw Better with AR Drawing" />
              </div>
            </div>
          </FadeAnimate>
        </div>
      </div>
    </div>
  );
};

export default Section7;
